import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BookOpenIcon, ChevronDownIcon, Clock3Icon, ListChecksIcon } from 'lucide-react';
import { IMAGES, TOMOS } from '../data/landing';
export function SolutionSection() {
  const [openTomo, setOpenTomo] = useState<number | null>(0);
  return <section className="w-full bg-neutral-950 py-10 text-white sm:py-16" data-id="element-275" data-mp="3j95zra6njv46">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-276" data-mp="142sbit7r70l">
        <div className="mx-auto max-w-2xl text-center" data-id="element-277" data-mp="12rrnrv2efdp">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-yellow-400 px-3 py-1 text-xs font-black uppercase text-neutral-900" data-id="element-278" data-mp="3t96ml63qctd4">
            <BookOpenIcon className="h-3.5 w-3.5" data-id="element-279" data-mp="awi9idworrkf" /> La solución
          </span>
          <h2 className="mt-4 text-2xl font-black leading-tight sm:text-3xl lg:text-4xl" data-id="element-280" data-mp="5vume3bkvuvh">
            Este no es otro PDF de recetas.
          </h2>
          <p className="mt-3 text-base leading-relaxed text-neutral-300 sm:text-lg" data-id="element-281" data-mp="ftqt8ixhg3ns">
            Dominá las funciones ocultas de tu máquina y descubrí por qué miles de familias argentinas ya dejaron de usar el horno tradicional.
          </p>
        </div>

        <img src={IMAGES.mockupPrincipal} alt="Los 4 tomos del MegaPack Air Fryer Argentina" loading="lazy" decoding="async" fetchPriority="low" className="mx-auto mt-8 w-full max-w-2xl rounded-2xl drop-shadow-[0_24px_32px_rgba(0,0,0,0.5)]" data-id="element-282" data-mp="3b9yyqtdgr9h3" />

        <div className="mt-10" data-id="element-283" data-mp="3p9q4y7xqnlkj">
          <div className="mb-5 text-center" data-id="element-284" data-mp="3p8ovg7wdf74x">
            <p className="text-lg font-black text-white sm:text-xl" data-id="element-285" data-mp="3p7ngvtg5c2ig">
              Espiá el índice de cada tomo
            </p>
            <p className="mt-1 text-sm text-neutral-400" data-id="element-286" data-mp="2tdn14tg62aa">
              Una muestra de los clásicos argentinos que vas a poder hacer desde el primer día.
            </p>
          </div>

          <div className="grid gap-4 sm:grid-cols-2" data-id="element-287" data-mp="butv35wshsbc">
            {TOMOS.map((tomo, index) => {
            const isOpen = openTomo === index;
            return <motion.article key={tomo.numero} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.08
            }} className="overflow-hidden rounded-2xl border border-neutral-800 bg-neutral-900" data-id="element-288" data-mp="gu6fzl43opba" data-mpi={index}>
                  <button type="button" onClick={() => setOpenTomo(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`indice-${index}`} className="flex w-full items-start justify-between gap-4 p-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-yellow-400" data-id="element-289" data-mp="2hu30zkvun51r">
                    <span data-id="element-290" data-mp="30lvr97jjac5s">
                      <span className="inline-block rounded-md px-2.5 py-1 text-xs font-black uppercase text-neutral-900" style={{
                    backgroundColor: tomo.color
                  }} data-id="element-291" data-mp="30np1sxx9pgj2">
                        {tomo.numero}
                      </span>
                      <span className="mt-3 block text-xl font-bold text-white" data-id="element-292" data-mp="3hv6ivbxpoz1u">{tomo.titulo}</span>
                      <span className="mt-1.5 block text-sm text-neutral-400" data-id="element-293" data-mp="3mvcbovfpwrli">{tomo.descripcion}</span>
                      <span className="mt-3 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-neutral-300" data-id="element-294" data-mp="386okt2gth61w">
                        <Clock3Icon className="h-3.5 w-3.5" style={{
                      color: tomo.color
                    }} data-id="element-295" data-mp="3d3f1ns0g45od" />
                        {tomo.rango}
                      </span>
                    </span>
                    <ChevronDownIcon className={`mt-1 h-6 w-6 shrink-0 text-neutral-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-296" data-mp="341yojci8xpgg" />
                  </button>

                  <AnimatePresence initial={false} data-id="element-297" data-mp="2u6nkbo4gs0my">
                    {isOpen && <motion.div id={`indice-${index}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25
                }} className="overflow-hidden" data-id="element-298" data-mp="nf619fp29a3u">
                        <div className="border-t border-neutral-800 px-5 pb-5 pt-4" data-id="element-299" data-mp="2fg607zxgkzst">
                          <p className="text-sm leading-relaxed text-neutral-300" data-id="element-300" data-mp="2aixe5o96wbma">{tomo.enfoque}</p>
                          <div className="mt-4 rounded-xl bg-neutral-950 p-4" data-id="element-301" data-mp="25jayz99swlau">
                            <p className="flex items-center gap-2 text-xs font-black uppercase tracking-wider text-yellow-400" data-id="element-302" data-mp="20sktzx5aekgo">
                              <ListChecksIcon className="h-4 w-4" data-id="element-303" data-mp="1wrsjz1olcbjc" /> Índice destacado
                            </p>
                            <ol className="mt-3 space-y-2" data-id="element-304" data-mp="1rt7jr29c9ruw">
                              {tomo.destacados.map((receta, recipeIndex) => <li key={receta} className="flex items-start gap-2 text-sm text-neutral-200" data-id="element-305" data-mp="1mrrypa75vlci" data-mpi={recipeIndex}>
                                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] font-black text-neutral-950" style={{
                            backgroundColor: tomo.color
                          }} data-id="element-306" data-mp="1hvjo8a3wsgbo">
                                    {recipeIndex + 1}
                                  </span>
                                  {receta}
                                </li>)}
                            </ol>
                          </div>
                          <p className="mt-4 border-l-2 pl-3 text-xs font-semibold leading-relaxed text-neutral-400" style={{
                      borderColor: tomo.color
                    }} data-id="element-307" data-mp="p0vape5i10z2">
                            {tomo.masRecetas}
                          </p>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.article>;
          })}
          </div>
        </div>
      </div>
    </section>;
}